export default __webpack_public_path__ + "static/media/location-shared.c22469ac.svg";